module.exports = __webpack_public_path__ + "img/home--dark.01102de9.svg";